import { type FC } from 'react';
import type { SimplePointCloudProps, WithId } from '../types';
import { PointCloudMaterial } from './PointCloudMaterial';
import { PointCloudNode } from './PointCloudNode';

export interface SimplePointCloudExtendedProps extends WithId<SimplePointCloudProps> {
  getPointCloudMaterial: (material: string) => PointCloudMaterial | undefined;
  onViewerObjectReady: (isReady: boolean) => void;
  enableLoaderRetry: boolean;
}

export const SimplePointCloud: FC<SimplePointCloudExtendedProps> = (props) => {
  return <PointCloudNode {...props} octreeId={props.url} />;
};
